export const HeaderProperties = {
    height: "50px"
};
